export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const LOGIN_INTRANET = 'LOGIN_INTRANET';
export const LOGIN_INTRANET_SUCCESS = 'LOGIN_INTRANET_SUCCESS';
export const LOGIN_INTRANET_FAILED = 'LOGIN_INTRANET_FAILED';

export const LOGIN_EXTRANET = 'LOGIN_EXTRANET';
export const LOGIN_EXTRANET_SUCCESS = 'LOGIN_EXTRANET_SUCCESS';
export const LOGIN_EXTRANET_FAILED = 'LOGIN_EXTRANET_FAILED';

export const REFRESH_TOKEN = 'REFRESH_TOKEN';
